var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMessageIconRed(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 18,
    viewBox: "0 0 17 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.66667 2.33333H5C3.59987 2.33333 2.8998 2.33333 2.36502 2.60582C1.89462 2.8455 1.51217 3.22795 1.27248 3.69836C1 4.23314 1 4.9332 1 6.33333V10.6667C1 11.4416 1 11.8291 1.08519 12.147C1.31635 13.0098 1.99022 13.6836 2.85295 13.9148C3.17087 14 3.55836 14 4.33333 14V15.9463C4.33333 16.3903 4.33333 16.6123 4.42436 16.7263C4.50352 16.8255 4.62356 16.8832 4.75045 16.8831C4.89636 16.8829 5.06973 16.7442 5.41646 16.4668L7.40434 14.8765C7.81043 14.5517 8.01347 14.3892 8.23957 14.2737C8.44017 14.1712 8.65369 14.0963 8.87435 14.051C9.12306 14 9.38308 14 9.90312 14H11.1667C12.5668 14 13.2669 14 13.8016 13.7275C14.272 13.4878 14.6545 13.1054 14.8942 12.635C15.1667 12.1002 15.1667 11.4001 15.1667 10V9.83333M15.2678 2.23223C16.2441 3.20854 16.2441 4.79146 15.2678 5.76777C14.2915 6.74408 12.7085 6.74408 11.7322 5.76777C10.7559 4.79146 10.7559 3.20854 11.7322 2.23223C12.7085 1.25592 14.2915 1.25592 15.2678 2.23223Z",
    stroke: "#E20000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageIconRed);
export default __webpack_public_path__ + "static/media/MessageIconRed.c7f43c0d9f5c8415397773b7d6696ca7.svg";
export { ForwardRef as ReactComponent };